import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import Sticky from 'react-sticky-el';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink, CardAccordion, CardAccordionHeader, CardAccordionBody } from '../../../components';

import './OrganismosRepresentacao.scss';

class OrganismosRepresentacao extends Component {
  constructor(props) {
    super(props);

    this.images = images;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
    this.mobile = window.innerWidth < 768 ? true : false;

    console.log('window.width', window.innerWidth);
  }

  state = {
    legendaOpened: false,
  };

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  openLegenda = () => {
    const { legendaOpened } = this.state;
    console.log('openLegenda', legendaOpened);
    if (this.mobile === true) {
      this.setState({ legendaOpened: !legendaOpened });
    }
  };

  render = () => {
    const { legendaOpened } = this.state;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Organismos de Representacao - - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image">
          <img src={this.images.organismos.first_bg} />
        </div>

        <div className="organismos-representacao" ref="organismos-representacao">
          <section className="organismos-representacao-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header">
                          <h1 className="title gri_text gri_text--fixed">
                            Organismos de representação
                            <span className="gri_label">
                              GRI <b>102-21</b>
                            </span>
                          </h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Para defender os interesses dos associados, debatemos temas que contribuem para o
                            fortalecimento do mercado em fóruns, grupos e comissões.
                          </p>
                          <p>
                            Eles são formados por pessoas do próprio mercado, que participam voluntariamente desses
                            organismos. As discussões sobre melhorias na regulação são encaminhadas à Diretoria, podem
                            ser avaliadas em audiências públicas e são enviadas aos reguladores.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <div className="governanca-body">
            <div className="entenda-area-container">
              <section className="entenda-area-title">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <Fade bottom>
                        <h2 className="high bordered_text bordered_text--new bordered_text--dark-gray">
                          Entenda a formação dos grupos:
                        </h2>
                      </Fade>
                    </div>

                    <div className="col-4">
                      <Fade bottom>
                        <div className="card card--yellow">
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <img src={this.images.icons.hands} className="card__icon" />
                            </div>
                            <div className="card__content__body">
                              <p>
                                São seis <b className="yellow">fóruns de representação</b>, relacionados às atividades
                                do mercado e que contam com o apoio de comissões temáticas – grupos criados de acordo
                                com as necessidades de cada fórum e demandas do plano de ação.
                              </p>
                            </div>
                          </div>
                        </div>
                      </Fade>
                    </div>

                    <div className="col-4">
                      <Fade bottom>
                        <div className="card card--blue">
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <img src={this.images.icons.book} className="card__icon" />
                            </div>
                            <div className="card__content__body">
                              <p>
                                Temos também dois <b className="blue">fóruns de apoio</b> para tratar de temas jurídicos
                                e tributários.
                              </p>
                            </div>
                          </div>
                        </div>
                      </Fade>
                    </div>

                    <div className="col-4">
                      <Fade bottom>
                        <div className="card card--green">
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <img src={this.images.icons.circles} className="card__icon" />
                            </div>
                            <div className="card__content__body">
                              <p>
                                Os <b className="green">grupos consultivos</b> se dividem em permanentes, que dão
                                suporte aos produtos e serviços que oferecemos, e emergentes, que discutem temas
                                essenciais para o desenvolvimento do mercado e podem passar por todos os fóruns, mas não
                                estão incorporados à pauta específica de nenhum deles.
                              </p>
                            </div>
                          </div>
                        </div>
                      </Fade>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <section className="estrutura-area-title">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <h2 className="high bordered_text bordered_text--new bordered_text--dark-gray">
                      Conheça a estrutura de representação de 2019:
                    </h2>
                  </Fade>
                </div>
              </div>
            </section>

            <section className="estrutura-area-content">
              <div className="container">
                <div className="row content-row">
                  <div className="col-8 accordions">
                    <Fade bottom>
                      <CardAccordion
                        color="yellow"
                        header={
                          <CardAccordionHeader>
                            <h2 className="title">Fóruns de representação</h2>
                          </CardAccordionHeader>
                        }
                        content={
                          <CardAccordionBody>
                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Distribuição
                            </h4>
                            <ul>
                              <li>Autorregulação</li>
                              <li>Institucionais</li>
                              <li>Varejo</li>
                            </ul>

                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Estruturação de Mercado
                              <br />
                              de Capitais
                            </h4>
                            <ul>
                              <li>Renda Fixa</li>
                              <li>Renda Variável</li>
                            </ul>

                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Fundos Estruturados
                            </h4>
                            <ul>
                              <li>Direitos Creditórios</li>
                              <li>Imobiliários</li>
                              <li>Participações</li>
                            </ul>

                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Fundos Mútuos
                            </h4>
                            <ul>
                              <li>Autorregulação*</li>
                              <li>Gestão de Carteiras</li>
                              <li>Gestão de Patrimônio</li>
                              <li>Gestão de Riscos</li>
                            </ul>

                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Negociação
                            </h4>
                            <ul>
                              <li>Operacional Selic</li>
                              <li>Produtos de Tesouraria</li>
                            </ul>

                            <h4 className="legenda yellow">
                              <img src={this.images.icons.foruns} /> Serviços Fiduciários
                            </h4>
                            <ul>
                              <li>Autorregulação*</li>
                              <li>Administração e Custódia</li>
                              <li>Escrituração</li>
                              <li>Representação de Investidor não Residente</li>
                            </ul>
                            <div className="row">
                              <div className="col-12">
                                <p className="light-gray">
                                  <b>*</b> Atende aos fóruns de Gestão de Fundos Mútuos, Gestão de Fundos Estruturados e
                                  de Serviços Fiduciários.
                                </p>
                              </div>
                            </div>
                          </CardAccordionBody>
                        }
                      />
                    </Fade>

                    <Fade bottom>
                      <CardAccordion
                        color="blue"
                        header={
                          <CardAccordionHeader>
                            <h2 className="title">Fóruns de apoio</h2>
                          </CardAccordionHeader>
                        }
                        content={
                          <CardAccordionBody>
                            <h4 className="legenda blue">
                              <img src={this.images.icons.foruns} /> Jurídico
                            </h4>
                            <h4 className="legenda blue">
                              <img src={this.images.icons.foruns} /> Tributário
                            </h4>
                          </CardAccordionBody>
                        }
                      />
                    </Fade>

                    <Fade bottom>
                      <CardAccordion
                        color="green"
                        header={
                          <CardAccordionHeader>
                            <h2 className="title">Grupos consultivos</h2>
                          </CardAccordionHeader>
                        }
                        content={
                          <CardAccordionBody>
                            <h4 className="legenda green">
                              <img src={this.images.icons.permanentes} /> Certificação
                            </h4>
                            <h4 className="legenda green">
                              <img src={this.images.icons.permanentes} /> Educação
                            </h4>
                            <h4 className="legenda green">
                              <img src={this.images.icons.permanentes} /> Macroeconômico
                            </h4>
                            <h4 className="legenda green">
                              <img src={this.images.icons.permanentes} /> Precificação
                            </h4>

                            <h4 className="legenda green">
                              <img src={this.images.icons.emergentes} /> Cibersegurança
                            </h4>
                            <h4 className="legenda green">
                              <img src={this.images.icons.emergentes} /> Inovação
                            </h4>
                            <h4 className="legenda green">
                              <img src={this.images.icons.emergentes} /> Sustentabilidade
                            </h4>
                          </CardAccordionBody>
                        }
                      />
                    </Fade>
                  </div>

                  <div className="col-4 legenda-col">
                    <Sticky
                      mode={'top'}
                      stickyStyle={{
                        marginTop: 100,
                      }}
                      disabled={this.mobile}
                    >
                      <div
                        className={`card card--gray card--legenda ${legendaOpened ? `card--legenda--open` : ``}`}
                        onClick={() => this.openLegenda()}
                      >
                        <div className="card__content card__content--full">
                          <div className="card__content__header card__content__header--no-border">
                            <h2 className="title">Legenda</h2>
                            <img src={images.icons.chevron_dark_top} />
                          </div>
                          <div className="card__content__body">
                            <h4 className="legenda">
                              <img src={this.images.icons.foruns_dark} /> Fóruns
                            </h4>
                            <h4 className="legenda">
                              <img src={this.images.icons.comissoes_dark} /> Comissões
                            </h4>
                            <h4 className="legenda">
                              <img src={this.images.icons.permanentes_dark} /> Grupos consultivos permanentes
                            </h4>
                            <h4 className="legenda">
                              <img src={this.images.icons.emergentes_dark} /> Grupos consultivos emergentes
                            </h4>
                          </div>
                        </div>
                      </div>
                    </Sticky>
                  </div>
                </div>
              </div>
            </section>

            <section className="estrutura-area-bottom gradient-yellow">
              <div className="container">
                <div className="row">
                  <div className="col-12 grupos-supervisao">
                    <Fade bottom>
                      <div className="card card--yellow">
                        <div className="card__content card__content--full">
                          <div className="card__content__header">
                            <h2 className="title gri_text">Grupos de supervisão</h2>
                          </div>
                          <div className="card__content__body">
                            <div className="row">
                              <div className="col-5">
                                <h4>
                                  Comissões
                                  <br />
                                  de acompanhamento
                                </h4>
                                <p>
                                  São grupos que orientam a atuação da equipe interna de supervisão de mercados.
                                  Formados por representantes dos associados, eles analisam e aprovam os relatórios
                                  elaborados pela área. Também devem encaminhar, aos conselhos de regulação e melhores
                                  práticas, a análise técnica das investigações sobre instituições que descumpriram as
                                  exigências dos códigos de autorregulação.
                                </p>
                              </div>
                              <div className="col-1"></div>
                              <div className="col-5">
                                <h4>Conselhos de regulação e melhores práticas</h4>
                                <p>
                                  São responsáveis por instaurar e julgar processos envolvendo as instituições que
                                  seguem os nossos códigos de autorregulação e devem emitir deliberações e pareceres de
                                  orientação em relação aos procedimentos e possíveis irregularidades desses códigos.
                                  Para garantir a independência nas decisões, são formados por pessoas nomeadas pela
                                  Diretoria e por profissionais de outras entidades do mercado.
                                </p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <h2 className="yellow">Temos nove comissões e nove conselhos sobre os temas:</h2>
                                <ul>
                                  <li>Administração de Recursos de Terceiros</li>
                                  <li>Certificação</li>
                                  <li>Distribuição de Produtos de Investimentos</li>
                                  <li>FIP e FIEE</li>
                                  <li>Mercado de Capitais</li>
                                  <li>Negociação de Instrumentos Financeiros</li>
                                  <li>Serviços Qualificados</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>

            <section className="organismos-footer-area governanca-footer">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade>
                      <div className="box-pill box-pill--green box-pill--center">
                        <div className="box-pill__content box-pill__content--full">
                          <div className="row">
                            <div className="col col-3 col--image">
                              <img
                                src={this.images.organismos.pessoa1}
                                className="pessoa_destaque pessoa_destaque--1"
                              />
                            </div>
                            <div className="col col-9 col--text">
                              <h4>Conheça o comitê que comanda a nossa equipe interna</h4>
                              <DelayLink
                                to="/governanca-corporativa/comite-executivo"
                                className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                              >
                                Explorar
                              </DelayLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  };
}

export { OrganismosRepresentacao };
